import React from 'react';

const OurStory = () => {
  const timeline = [
    {
      year: '2011',
      title: 'The Beginning',
      description: 'EYME LLC was founded with a vision to simplify Amazon selling for manufacturers and distributors.'
    },
    {
      year: '2015',
      title: 'Expansion',
      description: 'Reached 1,000+ vendor partnerships and expanded warehouse operations across multiple states.'
    },
    {
      year: '2018',
      title: 'Innovation',
      description: 'Launched AI-driven PPC optimization platform, revolutionizing our advertising approach.'
    },
    {
      year: '2021',
      title: 'Growth',
      description: 'Surpassed $50M in annual revenue and established partnerships with major platforms like Walmart.'
    },
    {
      year: '2024',
      title: 'Leadership',
      description: 'Now supporting 2,000+ vendors with $45M+ annual revenue and industry-leading satisfaction rates.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section 
        className="relative py-32 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHx0ZWFtJTIwY29sbGFib3JhdGlvbnxlbnwwfHx8fDE3NzIyNzA2ODR8MA&ixlib=rb-4.1.0&q=85)'
        }}
      >
        <div className="absolute inset-0 bg-slate-900/85"></div>
        <div className="container mx-auto px-6 relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold text-white text-center mb-6">
            Our <span className="text-[#FF9900]">Story</span>
          </h1>
          <p className="text-xl text-gray-200 text-center max-w-3xl mx-auto">
            From humble beginnings to e-commerce excellence
          </p>
        </div>
      </section>

      {/* Story Content */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-slate-900 mb-8">
              A Vision to <span className="text-[#FF9900]">Simplify</span> Amazon Selling
            </h2>
            
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              In 2011, our founders recognized a significant challenge facing manufacturers and brand owners: 
              navigating the complexities of Amazon's marketplace. While the platform offered unprecedented 
              access to millions of customers, the logistics, marketing, and operational demands were 
              overwhelming for many businesses.
            </p>

            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              EYME LLC was born from a simple yet powerful idea: what if we could handle every aspect of 
              Amazon selling, allowing brands to focus on what they do best—creating exceptional products? 
              We started by purchasing inventory directly from manufacturers and managing the entire sales 
              process, from warehouse storage to customer service.
            </p>

            <h3 className="text-3xl font-bold text-slate-900 mb-6 mt-12">
              Growth into a <span className="text-[#FF9900]">Full-Service</span> E-Commerce Powerhouse
            </h3>

            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              As demand for our services grew, so did our capabilities. We invested heavily in technology, 
              building proprietary tools for inventory management, PPC optimization, and sales analytics. 
              Our warehouse network expanded across the United States, ensuring fast, reliable distribution 
              to Amazon fulfillment centers.
            </p>

            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              By 2018, we had become one of the leading Amazon service providers in the industry, known for 
              our data-driven approach and commitment to transparency. We introduced AI-powered advertising 
              campaigns that consistently outperformed traditional methods, helping our partners achieve 
              unprecedented growth.
            </p>

            <h3 className="text-3xl font-bold text-slate-900 mb-6 mt-12">
              Commitment to <span className="text-[#FF9900]">Transparency, Scalability</span>, and Long-Term Partnerships
            </h3>

            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              Today, EYME LLC is more than a service provider—we're a strategic partner in your success. 
              Our commitment to transparency means you always have full visibility into your sales performance, 
              inventory levels, and advertising metrics. We believe in clear communication and honest reporting.
            </p>

            <p className="text-gray-700 text-lg leading-relaxed mb-8">
              Scalability is at the core of our operations. Whether you're launching your first product or 
              managing thousands of SKUs, our infrastructure and expertise can adapt to your needs. And because 
              we view every relationship as a long-term partnership, we're invested in your continued growth 
              and success.
            </p>
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-slate-900 mb-16 text-center">
            Our <span className="text-[#FF9900]">Journey</span>
          </h2>
          
          <div className="max-w-4xl mx-auto">
            {timeline.map((item, index) => (
              <div key={index} className="flex mb-12 last:mb-0">
                <div className="flex flex-col items-center mr-8">
                  <div className="flex items-center justify-center w-16 h-16 bg-[#FF9900] text-white rounded-full font-bold text-lg">
                    {item.year}
                  </div>
                  {index !== timeline.length - 1 && (
                    <div className="w-1 h-full bg-gray-300 mt-2"></div>
                  )}
                </div>
                <div className="flex-1 pb-12">
                  <h3 className="text-2xl font-bold text-slate-900 mb-2">{item.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurStory;
